export function handleServerHookForm(serverValidation, setError) {
    if (serverValidation === null || serverValidation === void 0 ? void 0 : serverValidation.length) {
        serverValidation.forEach((item) => {
            setError(item.field, {
                type: 'manual',
                message: `api.validation.${item.errors[0]}`,
            });
        });
    }
}
export function handleServerHookFormValidation(serverValidation, setError, mappings) {
    if (serverValidation === null || serverValidation === void 0 ? void 0 : serverValidation.length) {
        serverValidation.forEach((item) => {
            setError(item.field, {
                type: 'manual',
                message: mappings ? mappings[item.errors[0]] : item.errors[0],
            });
        });
    }
}
export function handleFormDataReset(data, reset) {
    reset(data);
}
export function composeValidation(params) {
    const newValidation = params.validation;
    newValidation.apiValidation = params.apiValidation;
    newValidation.objectToValidate = params.objectToValidate;
    return newValidation;
}
//# sourceMappingURL=index.js.map